import {IconButton, Tab, TabGroup, Text} from "@nike/eds";
import {SizedModal} from "./layout/SizedModal";
import {CopyToClipboard} from "react-copy-to-clipboard";
import React, {useContext, useEffect, useState} from "react";
import DownloadContext from "../providers/download-context";
import {PreviewLabelRequest} from "./model/PreviewLabelRequest";

export function DownloadModal() {

    const downloadCtx = useContext(DownloadContext);
    const [activeId, setActiveId] = React.useState("contentTab");
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const [base64EncodedPreviewLabel, setBase64EncodedPreviewLabel] = useState<string[]>([]);

    const handleDownloadClicked = async () => {
        const fileName = downloadCtx.payloadPath;
        fetch(downloadCtx.preSignedUrl).then(function (t) {
            return t.blob().then((b) => {
                const a = document.createElement("a");
                a.href = URL.createObjectURL(b);
                a.setAttribute("download", fileName);
                a.click();
            });
        });
    };

    const getBase64EncodedPreviewLabels = async () => {
        fetch(downloadCtx.previewLabelUrl, {
            method: 'POST',
            body: getRequestBody(),
            mode: 'cors',
            redirect: 'manual',
            headers: {
                'Authorization': 'Bearer ' + downloadCtx.token
            },
        })
            .then(async response => {
                const text = await response.text();
                if (response.ok) {
                    let jsonObj = JSON.parse(text);
                    setBase64EncodedPreviewLabel(jsonObj);
                } else {
                    console.log("something went wrong")
                }
            })

        function getRequestBody() {
            if (downloadCtx.contentEncoding !== null) {
                return JSON.stringify(new PreviewLabelRequest(atob(downloadCtx.content), 164, 98));
            }
            return JSON.stringify(new PreviewLabelRequest(downloadCtx.content, 164, 98));
        }
    };

    useEffect(() => {
        getBase64EncodedPreviewLabels()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <SizedModal
            isOpen={downloadCtx.isDisplayed}
            onDismiss={() => downloadCtx.onClose()}
            hideFade={true}
            headerSlot={
                <div>
                    <Text font={"title-3"} as={"h3"}>
                        Payload
                    </Text>
                    {downloadCtx.contentType === "application/zpl" ?
                        <div style={{paddingTop: "10px"}}>
                            <TabGroup name="tab-button-group" activeId="contentTab"
                                      onChange={e => setActiveId(e.target.id)}>
                                <Tab id="contentTab">Content</Tab>
                                <Tab id="previewTab">Preview</Tab>
                            </TabGroup>
                        </div>
                        :
                        // no need to display tabs for pdf
                        <div></div>
                    }
                </div>
            }
            footerSlot={
                <div
                    style={{
                        display: "grid",
                        gridGap: "10px",
                        gridTemplateColumns: "auto auto",
                        justifyContent: "start",
                    }}
                >
                    <CopyToClipboard text={downloadCtx.content}>
                        <IconButton
                            size={"small"}
                            icon="CopyPaste"
                            label={"CopyPaste"}
                        />
                    </CopyToClipboard>
                    <IconButton
                        size={"small"}
                        icon="Download"
                        label={"Download"}
                        onClick={() => handleDownloadClicked()}
                    />
                </div>
            }
        >
            {"application/pdf" === downloadCtx.contentType &&
                <object
                    data={downloadCtx.contentEncoding === "base64" ? "data:application/pdf;base64," + downloadCtx.content : downloadCtx.preSignedUrl}
                    type={"application/pdf"}
                    height={(windowHeight - 200) + "px"}
                    width={(windowWidth - 200) + "px"}/>
            }
            {"application/pdf" !== downloadCtx.contentType &&
                <div style={{maxHeight: "calc(100vh - 304px)"}}>
                    <Text font={"body-3"} as={"div"} hidden={activeId !== 'contentTab'}>
                        <pre
                            id="formattedContent">{downloadCtx.contentEncoding === "base64" ? atob(downloadCtx.content) : downloadCtx.content}</pre>
                    </Text>
                    {"application/zpl" === downloadCtx.contentType &&
                        <div style={{maxWidth: "450px"}} hidden={activeId !== 'previewTab'}>
                            {
                                base64EncodedPreviewLabel.map((base64EncodedPreviewLabel) => (
                                    <img style={{border: "1px solid black"}} height="750px" src={"data:image/png;base64," + base64EncodedPreviewLabel}/>
                                ))
                            }
                        </div>
                    }
                </div>
            }
        </SizedModal>
    );
};